<template>
    <div class="login">
        <div class="left">
            <el-image fit="cover" :src="imageHello" style="height: 100vh; width: 100%; float: left;" :lazy="true"></el-image>
        </div>
        <div class="right">
            <div class="login-wrapper">
                <div style="text-align: center">
                    <img src="../../assets/logo.svg" style="height: 50px;" alt="logo"/>
                </div>
                <br>
                <el-form ref="form" :model="loginForm" :rules="rules">
                    <el-form-item label="" prop="name">
                        <el-input v-model="loginForm.name" :placeholder="$strings('login/name')" clearable
                                  prefix-icon="el-icon-user"></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="password">
                        <el-input v-model="loginForm.password" :placeholder="$strings('login/password')" type="password"
                                  clearable
                                  prefix-icon="el-icon-lock"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="loginForm.keep">{{ $strings('login/keep') }}</el-checkbox>
                    </el-form-item>
                    <el-form-item class="login-action-wrapper">
                        <el-button type="primary" @click="onLogin('form')" :loading="loading">{{
                                $strings('login/login')
                            }}
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-divider></el-divider>
                <div style="text-align: center; font-size: 14px;">
                    <span>@2021 StringDigital</span>
                    <el-divider direction="vertical"></el-divider>
                    <span><a href="https://www.string-digital.com/">{{ $strings('login/about') }}</a></span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{ $strings('login/help') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ImageHello from '@/assets/images/hello.jpeg';
import md5 from "js-md5";
import {LoginDo} from "@/api/admin/api";
import {STORAGE_KEY_LOGIN_ROLE, STORAGE_KEY_LOGIN_TZ, STORAGE_KEY_LOGIN_USER_NAME} from "@/config/config";
import {SaveItem} from "@/utils/storage";

export default {
    name: "index",
    data() {
        return {
            imageHello: ImageHello,
            loading: false,
            loginForm: {keep: true, name: '', password: ''},
            rules: {
                name: [{required: true, message: this.$strings('login/error/username_empty'), trigger: 'blur'}],
                password: [
                    {required: true, message: this.$strings('login/error/password_empty'), trigger: 'blur'},
                    {min: 4, message: this.$strings('login/error/password_simple'), trigger: 'blur'},
                ]
            }
        }
    },
    mounted() {
        console.log('left image', this.imageHello)
    },
    methods: {
        onLogin(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return false
                }
                this.loading = true;
                LoginDo({
                    password: md5(this.loginForm.password),
                    username: this.loginForm.name,
                    keep: this.loginForm.keep
                }).then((resp) => {
                    SaveItem(STORAGE_KEY_LOGIN_ROLE, resp.data.data.role)
                    SaveItem(STORAGE_KEY_LOGIN_USER_NAME, resp.data.data.name)
                    SaveItem(STORAGE_KEY_LOGIN_TZ, resp.data.data.tz)
                    if (resp.data.data.cp_id.length > 0) {
                        this.$router.push({'path': '/cpsite/app'});
                    } else {
                        this.$router.push({'path': '/spsite/trx/summary'});
                    }
                }).finally(() => {
                    this.loading = false;
                });
            })
        }
    }
}
</script>

<style scoped lang="scss">
.login {
    display: flex;
    flex-direction: row;
    height: 100vh;

    .left {
        flex: 1;
    }

    .right {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        .login-wrapper {
            box-sizing: border-box;
            width: 18em;
            border-radius: 4px;
            padding: 1em;
            border: 1px solid #eee;
        }

        .login-action-wrapper {
            display: flex;
            justify-content: flex-end;
        }
    }
}


</style>